import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_POST } from '../../../constants/api';

const postCoOrder = createAsyncThunk('coOrders/postCoOrder',
  async (formData, { rejectWithValue }) => {
    try {
      const data = await authSet(METHOD_POST, '/co/orders', formData);
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || error?.data?.message || 'Failed to create order');
    }
  });

export default postCoOrder;
